import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-19387
// Показываем модалку база после закрытия модалки оверквоты
export const isShowBazModalAfterCloseOverquota: boolean = !!getFeature('show-baz-modal-after-close-overquota-modal');
export const allowedStatusesForBazModalAfterOverquota: string[] = getFeature('allowed-statuses-for-baz-modal-after-overquota') || [
    'started',
    'unblocked',
    'full_blocked',
];
export const productId: string = getFeature('baz-modal-product-id') || 'W256GB_1m_unlimited_autoload_force_trial';
export const helpLink: string = getFeature('baz-modal-help-link') || 'https://help.mail.ru/cloud_web/files/unlimited';
